import { ROUTES } from '@shared/constants/routes';

/**
 * BE ContentTypes discriminator (PascalCase) → içerik düzenleme route'u.
 * Kuyruk satırından ilgili içeriğe derin link için kullanılır.
 */
export function contentEditRoute(contentType: string, contentId: string): string | null {
  const template: Record<string, string> = {
    Article: ROUTES.ARTICLE_EDIT,
    Page: ROUTES.PAGE_EDIT,
    Sss: ROUTES.SSS_EDIT,
    Campaign: ROUTES.CAMPAIGN_EDIT,
  };
  const path = template[contentType];
  return path ? path.replace(':id', contentId) : null;
}
